import React from "react"

const Catagory = props => (
  <div className="Catagory">
    <strong className="CatagoryTitle">{props.catagory}</strong>
    {props.filter}
  </div>
)

export default Catagory